import "@/App.css";
import useLenis from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Stats } from "@/components/site/Stats";
import { Manifesto } from "@/components/site/Manifesto";
import { About } from "@/components/site/About";
import { Timeline } from "@/components/site/Timeline";
import { Values } from "@/components/site/Values";
import { LogoStrip } from "@/components/site/LogoStrip";
import { Videos } from "@/components/site/Videos";
import { Press } from "@/components/site/Press";
import { Speaking } from "@/components/site/Speaking";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useLenis();
  return (
    <div className="bg-blue min-h-screen text-obsidian antialiased overflow-x-hidden">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <About />
        <Timeline />
        <Manifesto />
        <Values />
        <LogoStrip />
        <Videos />
        <Press />
        <Speaking />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
